import React from 'react';
import AppRoutes from "./routes/AppRoutes";
import { createTheme, ThemeProvider, StyledEngineProvider, adaptV4Theme } from "@mui/material/styles";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const theme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      main: '#174A84',
    },
  },
  typography: {
    fontFamily: [
      'lato',
    ].join(','),
  },
}));
const App = () => {

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <AppRoutes />
        </ThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
}

export default App;
